import { Component, EventEmitter, Input, Output } from '@angular/core';

export enum Svgs {
  ContractGenerating,
  ContractGenerated,
  ForUpload,
  DoneOutline
}
// ------------------------------------------------------------------------------------------
@Component({
  selector: 'lib-contract-state-base',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.css'],
})
export class BaseComponent {
  Svgs = Svgs;
  @Input() svg = Svgs.ContractGenerating;
  @Input() title = 'title';
  @Input() subtitle = 'subtitle';
  @Input() hasSubtitle = true;
  @Input() hasButton = false;
  @Input() buttonText = 'Finalizar';
  @Input() hasStatusBar = false;
  @Input() statusBarValue = 40;
  @Input() hasLoader = false;
  @Input() hasDownloadIcon = false;
  @Output() buttonPressed = new EventEmitter<void>();
  // ------------------------------------------------------------------------------------------
  onClick() {
    this.buttonPressed.emit();
  }
}
